import React, { useState, useEffect } from "react";
import { modalLoaderUiResolver } from "./ModalLoader";
import { ModalHeader, ModalBody, ModalActionToolbar } from "./tableStyles";
import SimpleModal from "../../SimpleModal";
import { ReactTable } from "../../SimpleForm/ReactTable";
import filterData from "../_Utils/filterData";

const TableLoader = ({
  input,
  meta,
  schemaProps,
  hidden,
  maxLength,
  disabled,
  inputType,
  value,
  formApi,
  ...rest
}) => {
  const { form_ui_name } = rest;
  const formType = form_ui_name.slice(6);
  const { fromField, toField, buttonText } = schemaProps.widgetConfig;
  const formValues = formApi.getState().values;
  let [infoMessage, setInfoMessage] = useState("");
  let [modalData, setModalData] = useState(
    fromField ? formValues[fromField] : null
  );
  const ui = modalLoaderUiResolver(`${form_ui_name}_${fromField}`);
  const [checkedItems, setCheckedItems] = useState([]);
  const [selectedAll, setSelectedAll] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  useEffect(() => {
    let data, message;
    if (modalData) [data, message] = filterData(modalData);
    setInfoMessage(message);
    setModalData(data);
  }, []);
  const toggleModal = function (e) {
    e.preventDefault();
    setModalOpen(!modalOpen);
  };
  const handleCheck = (e, itemChecked) => {
    if (e?.currentTarget?.checked) {
      return setCheckedItems([...checkedItems, itemChecked]);
    }
    setCheckedItems(
      checkedItems.filter((n) => n.itemKey !== itemChecked.itemKey)
    );
  };
  const handleSelectAll = (e, all) => {
    const isChecked = e?.currentTarget?.checked;
    const rows = all?.data || [];
    setSelectedAll(isChecked);
    if (isChecked) {
      const newCheckedItems = rows.map((itemData) => {
        return {
          itemData,
          itemKey: ui.createItemKey(formType, itemData),
        };
      });
      return setCheckedItems([...newCheckedItems]);
    }
    setCheckedItems([]);
  };
  const handleFinish = () => {
    // parse out itemKey just keep itemData
    let oldData = toField ? formApi.getState().values[toField] : [];
    let newData = checkedItems
      .slice(0)
      .reverse()
      .map((item) => item.itemData);
    // convert item fields if necessary
    let additionalInfo = ui.getFormFields(formType, formValues);
    additionalInfo = {
      ...additionalInfo,
      rowLength: formValues[toField] ? formValues[toField].length : 0,
    };
    newData = ui.convertItemFields
      ? ui.convertItemFields(formType, newData, additionalInfo)
      : newData;
    newData = [...oldData, ...newData];
    formApi.change(toField, newData);

    // reset modal state
    setCheckedItems([]);
    setSelectedAll(false);
    setModalOpen(false);
  };
  //   const [pageCount, setPageCount] = React.useState(0);

  const checkBoxColumn = {
    Header: (all) => {
      return (
        <>
          <input
            type="checkbox"
            name="selection"
            className="usa-checkbox__input"
            id={`allListed`}
            onChange={(e) => e}
            checked={selectedAll}
            onClick={(e) => {
              handleSelectAll(e, all);
            }}
            value={""}
          />
          <label
            className="usa-checkbox__label"
            style={{ margin: 0 }}
            htmlFor={`allListed`}
            onChange={(e) => e}
            checked={selectedAll}
          />
        </>
      );
    },
    id: "checkbox",
    disableSortBy: true,
    fixedWidth: 42,
    Cell: ({ row: { original } }) => {
      const itemKey = ui.createItemKey(formType, original);
      let checked =
        checkedItems &&
        checkedItems.some((n) => {
          return n.itemKey === itemKey;
        });
      return (
        <>
          <input
            type="checkbox"
            name="selection"
            className="usa-checkbox__input"
            id={`${itemKey}`}
            onChange={(e) => e}
            checked={checked}
            onClick={(e) => {
              handleCheck(e, { itemKey, itemData: { ...original } });
            }}
            value={itemKey}
          />
          <label
            className="usa-checkbox__label"
            style={{
              padding: 0,
              margin: "0 0 0 8px",
            }}
            htmlFor={`${itemKey}`}
            onChange={(e) => e}
            checked={checked}
          />
        </>
      );
    },
  };
  ui.columns = [checkBoxColumn, ...ui.columns];
  const checkedItemsCount =
    checkedItems && checkedItems.length ? checkedItems.length : 0;
  const dataCount = modalData && modalData.length ? modalData.length : 0;

  return (
    <>
      <br />
      <button
        onClick={(e) => {
          toggleModal(e);
        }}
        disabled={!modalData || !modalData.length}
        className="usa-button btn-extra-wide add_modal_open"
      >
        {buttonText}
      </button>
      <br />
      <br />
      {ui && (
        <SimpleModal
          toggleModal={toggleModal}
          modalStatus={modalOpen}
          renderButton={() => null}
          minWidth={"40%"}
          customStyles={{
            width: "70%",
            maxWidth: "70%",
            padding: "0px",
          }}
          // onRequestClose={() => closeReassignModal()}
        >
          <ModalHeader>
            <h3>Add Worksite(s)</h3>
          </ModalHeader>
          <ModalBody>
            <p className="pwd-description">
              Select the worksites below from your Prevailing Wage
              Determination, which are relevant to the employment described in
              this application.
              <br />
            </p>
            <p className="selection-label">{infoMessage}</p>
            <p className="selection-label">{`${checkedItemsCount} of ${dataCount} selected`}</p>
            <ReactTable columns={ui.columns} data={modalData} />
          </ModalBody>
          <ModalActionToolbar>
            <button
              className="usa-button btn-extra-wide"
              disabled={!checkedItems.length}
              onClick={handleFinish}
            >
              Finish
            </button>
          </ModalActionToolbar>
        </SimpleModal>
      )}
    </>
  );
};

export default TableLoader;
